import './stream.css';

export default function SaveStreamModal({
  opened,
  onClose,
  streamers,
  breakCategories,
  filteredBreakSubcategories,
  selectedStreamerId,
  selectedBreakCategoryId,
  selectedBreakSubcategoryId,
  setSelectedStreamerId,
  setSelectedBreakCategoryId,
  setSelectedBreakSubcategoryId,
  isLoadingLookups,
  isSavingStream,
  uploadedFileName,
  uploadedRowCount,
  savedStreamMessage,
  onSave,
}) {
  if (!opened) return null;

  return (
    <div
      className="rc-backdrop srv-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="rc-dialog srv-dialog">
        <div className="rc-dialog__head srv-dialog__head">
          <h2 className="srv-dialog__title">
            Save Stream
          </h2>
          <div className="srv-sub">
            Persist the parsed stream with the <code>/api/stream/save</code> payload and lookup selections.
          </div>
        </div>

        <div className="rc-dialog__body srv-dialog__body">
          <div className="rc-field">
            <label className="rc-label">Streamer</label>
            <select
              className="rc-select srv-select"
              value={selectedStreamerId}
              onChange={(e) => setSelectedStreamerId(e.target.value)}
              disabled={isLoadingLookups || isSavingStream}
            >
              {streamers.length === 0
                ? <option value="">No streamers configured yet</option>
                : streamers.map((s) => (
                    <option key={s.id} value={String(s.id)}>
                      {s.displayName || s.display_name}
                    </option>
                  ))
              }
            </select>
          </div>

          <div className="rc-field">
            <label className="rc-label">Break Category</label>
            <select
              className="rc-select srv-select"
              value={selectedBreakCategoryId}
              onChange={(e) => setSelectedBreakCategoryId(e.target.value)}
              disabled={isLoadingLookups || isSavingStream}
            >
              {breakCategories.length === 0
                ? <option value="">No break categories configured yet</option>
                : breakCategories.map((c) => (
                    <option key={c.id} value={String(c.id)}>
                      {c.displayName || c.display_name}
                    </option>
                  ))
              }
            </select>
          </div>

          <div className="rc-field">
            <label className="rc-label">Subcategory</label>
            <select
              className="rc-select srv-select"
              value={selectedBreakSubcategoryId}
              onChange={(e) => setSelectedBreakSubcategoryId(e.target.value)}
              disabled={isLoadingLookups || isSavingStream || !selectedBreakCategoryId}
            >
              {filteredBreakSubcategories.length === 0
                ? <option value="">No subcategories for this category</option>
                : filteredBreakSubcategories.map((s) => (
                    <option key={s.id} value={String(s.id)}>
                      {s.displayName || s.display_name}
                    </option>
                  ))
              }
            </select>
          </div>

          <div className="srv-upload-details">
            <div className="srv-upload-details__title">Upload Details</div>
            <div className="srv-upload-details__file">
              {uploadedFileName || 'No file uploaded'}
            </div>
            <div className="srv-upload-details__rows">
              {uploadedRowCount || 0} rows ready to save
            </div>
            {savedStreamMessage && (
              <div className="srv-upload-details__saved">{savedStreamMessage}</div>
            )}
          </div>
        </div>

        <div className="rc-dialog__actions">
          <button
            className="rc-btn"
            onClick={onClose}
            disabled={isSavingStream}
          >
            Cancel
          </button>
          <button
            className="rc-btn rc-btn--primary"
            onClick={onSave}
            disabled={isSavingStream || isLoadingLookups}
          >
            {isSavingStream ? 'Saving…' : 'Save Stream'}
          </button>
        </div>
      </div>
    </div>
  );
}
